import React, { Component } from "react";
import { connect } from "react-redux";
import { isMobile } from 'react-device-detect';
import { Select } from '../../ui';

import pymeImage from '../../../assets/pyme/pyme.png';
import { setClientValue } from "../../../actions";
import { mapSelectList, disabledCities } from "../../../helpers";
import { options, pyme } from "../../../operations";
import { Title, Body } from '../../Common/Form';
import Continue from "../../Common/Continue";
import Text from '../../Common/Form/Text';

import iconHouse from '../../../assets/icons/icon-house.svg';

class PymeForm_2 extends Component {

  constructor(props) {
    super(props);
    this.state = {
      continue: false,
    };

    this.continueCondition = this.continueCondition.bind(this);
    this.getContent = this.getContent.bind(this);
  }

  componentDidMount() {
    const { getDepartments, getOccupations } = this.props;
    this.checkContinueState(null);
    getDepartments();
    getOccupations();
  }

  componentDidUpdate(prevProps, prevState) {
    this.checkContinueState(prevState);
  }

  continueCondition() {

    const {
      occupation,
      addressState,
      addressCity
    } = this.props;

    return (
      occupation != null &&
      addressState != null &&
      (
        addressState.label != 'CANELONES' ||
        addressCity != null
      )
    );
  }

  checkContinueState(prevState) {
    if (this.continueCondition()) {
      if (prevState === null || !prevState.continue) this.setState({ continue: true });
    } else {
      if (prevState === null || prevState.continue) this.setState({ continue: false });
    }
  }

  getContent() {
    const {
      occupation, showError,
      onValueChange, occupations,
      addressState, onDepartmentChange,
      departments, addressCity,
      cities, onCityChange
    } = this.props;

    return (
      <div>
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿Cuál es la actividad de tu PYME?
        </Text>
        <Select
          id="occupation"
          name="occupation"
          leftIcon={iconHouse}
          value={occupation}
          onChange={(event) => { onValueChange('occupation', event) }}
          options={mapSelectList(occupations)}
          showAlert={showError && !occupation}
          disabled={(occupations && occupations.length < 1)}
          isLoading={(occupations && occupations.length < 1)}
        />
        <Text style={{ paddingTop: '25px'}} className="Text-question">
          ¿En que departamento se encuentra?
        </Text>
        <Select
          id="addressState"
          name="addressState"
          leftIcon={iconHouse}
          value={addressState}
          onChange={onDepartmentChange}
          options={mapSelectList(departments)}
          showAlert={showError && !addressState}
          disabled={(departments && departments.length < 1)}
          isLoading={(departments && departments.length < 1)}
        />
        {addressState && addressState.label === 'CANELONES' &&
          <div>
            <Text style={{ paddingTop: '25px'}} className="Text-question">
              ¿En que ciudad se encuentra?
            </Text>
            <Select
              id="addressCity"
              name="addressCity"
              leftIcon={iconHouse}
              value={addressCity}
              onChange={onCityChange}
              options={mapSelectList(cities.filter(citie => !disabledCities.includes(parseInt(citie.clave, 10))))}
              showAlert={showError && !addressCity}
              disabled={(cities && cities.length < 1)}
              isLoading={(addressState && cities && cities.length < 1)}
            />
          </div>
        }
      </div>
    );
  }

  render() {

    const { continue: toContinue } = this.state;

    return (
      <div>
        <div className="Pyme-Form">
          <div className="Pyme-Form-icon">
            <img src={pymeImage} alt="pyme" />
          </div>
          <div>
            <div className="Pyme-Form-wrapper">
              <Text className="Text-question">
                Contános sobre tu PYME
              </Text>
              <Body columnContent={this.getContent} />
            </div>
          </div>
        </div>
        <Continue state={toContinue} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    showError: state.steps.showError,

    occupation: state.client.occupation,
    addressState: state.client.addressState,
    addressCity: state.client.addressCity,

    occupations: state.options.occupations,
    departments: state.options.departments,
    cities: state.options.cities,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getDepartments: () => {
      dispatch(options.getDepartments());
    },
    getOccupations: () => {
      dispatch(pyme.getOccupations());
    },
    onValueChange: (type, value) => {
      dispatch(setClientValue(type, value));
    },
    onDepartmentChange: (addressState) => {
      dispatch(options.setDepartment(addressState));
    },
    onCityChange: (addressCity) => {
      dispatch(options.setCity(addressCity));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PymeForm_2);